module.exports = __webpack_public_path__ + "static/media/game-environment.f24f21bf.png";